module.exports = __webpack_public_path__ + "img/组 12944.c157181b.png";